import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21.8799 19.52L12.8799 3.47C12.5299 2.84 11.4899 2.84 11.1399 3.47L2.12994 19.52C1.95994 19.83 1.95994 20.21 2.12994 20.51C2.30994 20.81 2.63994 21 2.98994 21H21.0099C21.3599 21 21.6899 20.81 21.8699 20.51C22.0499 20.2 22.0499 19.83 21.8699 19.52H21.8899H21.8799ZM11.0099 9.59H13.0099V14.59H11.0099V9.59ZM11.0099 15.34H13.0099V17.34H11.0099V15.34Z" fill={ fill || 'currentColor' } />
    </svg>
);
